import { z } from "zod";
import { BillingTermsInputSchema } from "./billing-schemas";
import { CommercialDocumentKindSchema } from "./commercial-documents";
import { CommercialTermSchema } from "./commercial-terms";
import { OpaqueIdSchema } from "./schemas";

/**
 * Signed order forms and change orders, as the Billing tab sees them (ADR-0073): what was signed,
 * its commercial terms as written, and the billing terms it was set up as, if it has been.
 */
export const BillingSignedDocumentSchema = z.strictObject({
  documentId: OpaqueIdSchema,
  kind: CommercialDocumentKindSchema,
  title: z.string().min(1).max(200),
  reference: z.string().min(1).max(80),
  toolName: z.string().max(200),
  signedOn: z.iso.date(),
  /** The filed signed copy in the customer's documents, to open from the Billing tab. */
  customerDocumentId: OpaqueIdSchema,
  commercialTerms: z.array(CommercialTermSchema).max(40),
  /** The billing terms set up from this document; null until someone sets them up. */
  termsId: OpaqueIdSchema.nullable(),
});
export type BillingSignedDocument = z.infer<typeof BillingSignedDocumentSchema>;

export const BillingSignedDocumentsResponseSchema = z.strictObject({
  documents: z.array(BillingSignedDocumentSchema).max(200),
});

/** Approved terms set up from one signed document: the terms as reviewed in the form. */
export const BillingTermsFromDocumentSchema = z.strictObject({
  documentId: OpaqueIdSchema,
  terms: BillingTermsInputSchema,
});
export type BillingTermsFromDocument = z.infer<typeof BillingTermsFromDocumentSchema>;
